module.exports = __webpack_public_path__ + "img/atlas_thumb.a68dbcd0.jpg";